const SITE_URL = 'https://magicparktimes.com';

const ORGANIZATION_SCHEMA = {
  '@type': 'Organization',
  name: 'Magic Park Times',
  url: SITE_URL,
  logo: `${SITE_URL}/images/pwa/android/android-launchericon-512-512.png`,
};

const PARK_NAMES = {
  'disneyland-paris': 'Disneyland Paris',
  'walt-disney-studios': 'Disney Adventure World',
  'disneyland-california': 'Disneyland California',
  'disney-california-adventure': 'Disney California Adventure',
  'magic-kingdom': 'Magic Kingdom',
  epcot: 'Epcot',
  'hollywood-studios': 'Hollywood Studios',
  'animal-kingdom': 'Animal Kingdom',
  'tokyo-disneyland': 'Tokyo Disneyland',
  'tokyo-disneysea': 'Tokyo DisneySea',
  'shanghai-disneyland': 'Shanghai Disneyland',
  'hong-kong-disneyland-park': 'Hong Kong Disneyland',
  'universal-studios': 'Universal Studios Florida',
  'islands-of-adventure': 'Islands of Adventure',
  'universal-studios-california': 'Universal Studios California',
  'universal-studios-beijing': 'Universal Studios Beijing',
  'universal-studios-singapore': 'Universal Studios Singapore',
  efteling: 'Efteling',
  phantasialand: 'Phantasialand',
  'europa-park': 'Europa-Park',
  toverland: 'Toverland',
  'walibi-belgium': 'Walibi Belgium',
  'walibi-holland': 'Walibi Holland',
  'walibi-rhone-alpes': 'Walibi Rhône-Alpes',
  'parc-asterix': 'Parc Astérix',
  futuroscope: 'Futuroscope',
  aquascope: 'Aquascope',
  puydufou: 'Le Puy du Fou',
  'le-pal': 'Le Pal',
  nigloland: 'Nigloland',
  'plopsaland-de-panne': 'Plopsaland Belgium',
  gardaland: 'Gardaland',
  mirabilandia: 'Mirabilandia',
  'movie-park-germany': 'Movie Park Germany',
  'parque-de-atracciones-de-madrid': 'Parque de Atracciones de Madrid',
  portaventura: 'PortAventura',
  'ferrari-land': 'Ferrari Land',
  energylandia: 'Energylandia',
  'grona-lund': 'Gröna Lund',
  bellewaerde: 'Bellewaerde',
  bobbejaanland: 'Bobbejaanland',
  'seaworld-orlando': 'SeaWorld Orlando',
  'busch-gardens-tampa': 'Busch Gardens Tampa',
  'legoland-florida': 'LEGOLAND Florida',
  'legoland-deutschland': 'LEGOLAND Deutschland',
  'knotts-berry-farm': "Knott's Berry Farm",
  'alton-towers': 'Alton Towers',
  'thorpe-park': 'Thorpe Park',
  carowinds: 'Carowinds',
  kennywood: 'Kennywood',
  'heide-park': 'Heide Park',
  knoebels: 'Knoebels',
  'silver-dollar-city': 'Silver Dollar City',
  'la-ronde': 'La Ronde',
  'kings-island': 'Kings Island',
  hersheypark: 'Hersheypark',
  'lotte-world': 'Lotte World',
  'six-flags-qiddiyacity': 'Six Flags Qiddiya City',
  'typhoon-lagoon': 'Typhoon Lagoon',
  'blizzard-beach': 'Blizzard Beach',
  rulantica: 'Rulantica',
  traumatica: 'Traumatica',
  'epic-universe': 'Epic Universe',
  'volcano-bay': "Universal's Volcano Bay",
};

const PUBLIC_PARK_SLUG_ALIASES = {
  'disney-adventure-world': 'walt-disney-studios',
  'plopsaland-belgium': 'plopsaland-de-panne',
};

const INTERNAL_PARK_PUBLIC_SLUGS = {
  'disneyland-paris': '',
  'walt-disney-studios': 'disney-adventure-world',
  'plopsaland-de-panne': 'plopsaland-belgium',
};

const LEGACY_LOCALE_PREFIXES = new Set(['fr', 'en', 'es', 'it', 'de']);

const LEGACY_ROUTE_REDIRECTS = {
  '/disneyland-park': '/',
  '/disneyland-paris': '/',
  '/parc/disneyland-park': '/',
  '/parc/disneyland-paris': '/',
  '/disney-adventure-world/shows': '/disney-adventure-world',
  '/disney-adventure-world/restaurants': '/disney-adventure-world',
  '/disney-adventure-world/map': '/disney-adventure-world',
  '/studios/shows': '/disney-adventure-world',
  '/studios/restaurants': '/disney-adventure-world',
  '/studios/map': '/disney-adventure-world',
  '/studios': '/disney-adventure-world',
  '/walt-disney-studios/shows': '/disney-adventure-world',
  '/walt-disney-studios/restaurants': '/disney-adventure-world',
  '/walt-disney-studios/map': '/disney-adventure-world',
  '/walt-disney-studios': '/disney-adventure-world',
  '/plopsaland-de-panne': '/plopsaland-belgium',
  '/portaventura/ferrari-land': '/ferrari-land',
};

const STATIC_ROUTE_META = {
  '/': {
    title: "Magic Park Times - Temps d'attente en direct pour 60 parcs à thème",
    description: "Temps d'attente en direct pour 60 parcs à thème : Europa-Park, Efteling, Parc Astérix, Phantasialand, PortAventura, Gardaland, Disneyland Paris, Universal Studios et bien plus. Files d'attente en temps réel, horaires et prévisions d'affluence.",
    image: `${SITE_URL}/images/og/og-home.jpg`,
  },
  '/shows': {
    title: 'Spectacles Disneyland Paris - Horaires en direct | Magic Park Times',
    description: 'Horaires des spectacles, parades et rencontres de Disneyland Paris en temps réel pour organiser votre journée sans perdre le fil.',
    image: `${SITE_URL}/images/og/og-shows.jpg`,
  },
  '/restaurants': {
    title: 'Restaurants Disneyland Paris - Guide & Infos | Magic Park Times',
    description: 'Guide des restaurants et points de restauration de Disneyland Paris avec infos pratiques pour choisir où manger pendant votre visite.',
    image: `${SITE_URL}/images/og/og-restaurants.jpg`,
  },
  '/parks': {
    title: 'Tous les parcs - Magic Park Times',
    description: "Explorez les parcs suivis par Magic Park Times en Europe, Amérique et Asie, avec accès rapide aux temps d'attente, horaires et infos utiles.",
    image: `${SITE_URL}/images/og/og-parks.jpg`,
  },
  '/parc-asterix': {
    title: "Temps d'attente Parc Astérix en direct | Magic Park Times",
    description: "Temps d'attente Parc Astérix en direct : suivez les files d'attente des attractions comme Toutatis, OzIris, Tonnerre 2 Zeus, Pégase Express et Menhir Express, avec horaires et infos utiles.",
    image: `${SITE_URL}/images/og/og-parc-asterix.jpg`,
  },
  '/puydufou': {
    title: 'Programme du jour Puy du Fou - Horaires spectacles | Magic Park Times',
    description: "Programme du jour Puy du Fou : horaires des spectacles aujourd'hui et demain, ouverture du parc, restaurants et repères pour organiser votre journée.",
    image: `${SITE_URL}/images/og/og-home.jpg`,
  },
  '/about': {
    title: 'A propos - Magic Park Times',
    description: "Découvrez Magic Park Times, la plateforme de référence pour suivre les temps d'attente et préparer vos visites dans les parcs à thème.",
    image: `${SITE_URL}/images/og/og-about.jpg`,
  },
  '/conditions-utilisation': {
    title: "Conditions d'utilisation et abonnements - Magic Park Times",
    description: "Consultez les conditions d'utilisation et d'abonnement de Magic Park Times, incluant les comptes membres, les alertes temps d'attente, Stripe et la résiliation.",
    image: `${SITE_URL}/images/og/og-about.jpg`,
  },
  '/conditions-generales-vente': {
    title: "Conditions d'utilisation et abonnements - Magic Park Times",
    description: "Consultez les conditions d'utilisation et d'abonnement de Magic Park Times, incluant les comptes membres, les alertes temps d'attente, Stripe et la résiliation.",
    image: `${SITE_URL}/images/og/og-about.jpg`,
  },
  '/politique-confidentialite': {
    title: 'Politique de confidentialité - Magic Park Times',
    description: "Consultez la politique de confidentialité de Magic Park Times, incluant les données de compte, d'abonnement, de paiement et de notifications.",
    image: `${SITE_URL}/images/og/og-about.jpg`,
  },
  '/contact': {
    title: 'Contact - Magic Park Times',
    description: "Contactez l'équipe Magic Park Times pour une question, une suggestion ou un signalement lié aux données des parcs.",
    image: `${SITE_URL}/images/og/og-contact.jpg`,
  },
  '/support-us': {
    title: 'Nous soutenir - Magic Park Times',
    description: 'Soutenez Magic Park Times pour aider à maintenir les données live, les outils de visite et les améliorations de la plateforme.',
    image: `${SITE_URL}/images/og/og-support-us.jpg`,
  },
  '/map': {
    title: 'Carte interactive - Magic Park Times',
    description: "Carte interactive Magic Park Times pour localiser attractions, restaurants et services avec les données utiles de votre visite.",
    image: `${SITE_URL}/images/og/og-map.jpg`,
  },
  '/my-pass': {
    title: 'Mon Pass Annuel - Magic Park Times',
    description: 'Suivez vos informations de pass annuel et gardez vos outils de visite à portée de main sur Magic Park Times.',
    image: `${SITE_URL}/images/og/og-home.jpg`,
  },
  '/asterix-pass': {
    title: 'Pass Parc Astérix - Magic Park Times',
    description: 'Retrouvez les informations utiles autour du pass Parc Astérix et préparez votre visite avec Magic Park Times.',
    image: `${SITE_URL}/images/og/og-parc-asterix.jpg`,
  },
  '/login': {
    title: 'Connexion - Magic Park Times',
    description: 'Connectez-vous à votre compte Magic Park Times.',
    image: `${SITE_URL}/images/og/og-login.jpg`,
  },
  '/signup': {
    title: 'Inscription - Magic Park Times',
    description: 'Créez votre compte Magic Park Times.',
    image: `${SITE_URL}/images/og/og-signup.jpg`,
  },
  '/dispatch-max': {
    title: 'Dispatch Max - Magic Park Times',
    description: 'Accédez à Dispatch Max depuis Magic Park Times.',
    image: `${SITE_URL}/images/og/og-dispatch-max.jpg`,
  },
  '/deanrell-soundbox': {
    title: 'Deanrell Soundbox - Magic Park Times',
    description: 'Profitez de Deanrell Soundbox sur Magic Park Times.',
    image: `${SITE_URL}/images/og/og-deanrell-soundbox.jpg`,
  },
  '/disney-adventure-world': {
    title: "Disney Adventure World - Temps d'attente en direct | Magic Park Times",
    description: "Temps d'attente Disney Adventure World en direct : files d'attente, horaires et infos pratiques pour organiser votre visite.",
    image: `${SITE_URL}/images/og/og-walt-disney-studios.jpg`,
  },
};

const NOINDEX_PATH_PREFIXES = [
  '/admin',
  '/app',
  '/login',
  '/signup',
  '/profile',
  '/dashboard',
  '/billing',
  '/auth/callback',
  '/email-verified',
  '/tv',
  '/splash-test',
  '/deanrell-soundbox',
];

const RESERVED_NON_PARK_SEGMENTS = new Set([
  'admin',
  'app',
  'api',
  'about',
  'billing',
  'conditions-utilisation',
  'conditions-generales-vente',
  'politique-confidentialite',
  'terms',
  'privacy',
  'contact',
  'support-us',
  'parks',
  'shows',
  'restaurants',
  'map',
  'login',
  'signup',
  'dispatch-max',
  'deanrell-soundbox',
  'my-pass',
  'asterix-pass',
  'tv',
  'offline',
  'sitemap.xml',
]);

const PARK_GEO = {
  'disneyland-paris': { lat: 48.8722, lng: 2.7758 },
  'walt-disney-studios': { lat: 48.8685, lng: 2.7808 },
  efteling: { lat: 51.65, lng: 5.0474 },
  phantasialand: { lat: 50.7984, lng: 6.8799 },
  'europa-park': { lat: 48.2661, lng: 7.7219 },
  rulantica: { lat: 48.2661, lng: 7.7219 },
  traumatica: { lat: 48.2661, lng: 7.7219 },
  'parc-asterix': { lat: 49.1342, lng: 2.5707 },
  futuroscope: { lat: 46.6667, lng: 0.3667 },
  aquascope: { lat: 46.6667, lng: 0.3667 },
  puydufou: { lat: 46.89, lng: -0.93 },
  'le-pal': { lat: 46.5089, lng: 3.635 },
  nigloland: { lat: 48.2594, lng: 4.6144 },
  'walibi-belgium': { lat: 50.6961, lng: 4.5906 },
  'walibi-holland': { lat: 52.4401, lng: 5.7675 },
  'walibi-rhone-alpes': { lat: 45.6203, lng: 5.5717 },
  'plopsaland-de-panne': { lat: 51.0791, lng: 2.602 },
  toverland: { lat: 51.3977, lng: 5.9827 },
  gardaland: { lat: 45.4567, lng: 10.7139 },
  mirabilandia: { lat: 44.3381, lng: 12.2631 },
  portaventura: { lat: 41.0864, lng: 1.1559 },
  'ferrari-land': { lat: 41.0864, lng: 1.1559 },
  energylandia: { lat: 49.9706, lng: 19.2019 },
  'grona-lund': { lat: 59.3233, lng: 18.0979 },
  bellewaerde: { lat: 50.8472, lng: 2.9472 },
  bobbejaanland: { lat: 51.1978, lng: 4.9056 },
  'movie-park-germany': { lat: 51.6236, lng: 6.9728 },
  'parque-de-atracciones-de-madrid': { lat: 40.4114, lng: -3.7494 },
  'thorpe-park': { lat: 51.4036, lng: -0.5125 },
  'universal-studios': { lat: 28.4744, lng: -81.4687 },
  'islands-of-adventure': { lat: 28.4741, lng: -81.4715 },
  'epic-universe': { lat: 28.4414, lng: -81.4487 },
  'universal-studios-california': { lat: 34.1381, lng: -118.3534 },
  'universal-studios-beijing': { lat: 39.8633, lng: 116.68 },
  'seaworld-orlando': { lat: 28.4115, lng: -81.4617 },
  'busch-gardens-tampa': { lat: 28.0372, lng: -82.4194 },
  'legoland-florida': { lat: 27.9894, lng: -81.6867 },
  'knotts-berry-farm': { lat: 33.8443, lng: -117.9988 },
  'disneyland-california': { lat: 33.8121, lng: -117.919 },
  'disney-california-adventure': { lat: 33.8068, lng: -117.921 },
  'magic-kingdom': { lat: 28.4177, lng: -81.5812 },
  epcot: { lat: 28.3747, lng: -81.5494 },
  'hollywood-studios': { lat: 28.3578, lng: -81.5584 },
  'animal-kingdom': { lat: 28.3587, lng: -81.5908 },
  'typhoon-lagoon': { lat: 28.3653, lng: -81.5358 },
  'blizzard-beach': { lat: 28.3489, lng: -81.5748 },
  'tokyo-disneyland': { lat: 35.6329, lng: 139.8804 },
  'tokyo-disneysea': { lat: 35.6267, lng: 139.8851 },
  'shanghai-disneyland': { lat: 31.1433, lng: 121.658 },
  'hong-kong-disneyland-park': { lat: 22.313, lng: 114.0413 },
  'lotte-world': { lat: 37.5111, lng: 127.098 },
  'six-flags-qiddiyacity': { lat: 24.4539, lng: 46.485 },
};

const PARK_ENTITY_DETAILS = {
  'disneyland-paris': {
    sameAs: [
      'https://www.disneylandparis.com/',
      'https://fr.wikipedia.org/wiki/Disneyland_Paris',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Boulevard de Parc',
      addressLocality: 'Coupvray',
      postalCode: '77700',
      addressCountry: 'FR',
    },
  },
  'walt-disney-studios': {
    sameAs: [
      'https://www.disneylandparis.com/destinations/disney-adventure-world/',
      'https://fr.wikipedia.org/wiki/Disney_Adventure_World',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Avenue Paul Séramy',
      addressLocality: 'Chessy',
      postalCode: '77700',
      addressCountry: 'FR',
    },
  },
  'parc-asterix': {
    sameAs: [
      'https://www.parcasterix.fr/',
      'https://fr.wikipedia.org/wiki/Parc_Ast%C3%A9rix',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Parc Astérix',
      addressLocality: 'Plailly',
      postalCode: '60128',
      addressCountry: 'FR',
    },
  },
  'europa-park': {
    sameAs: [
      'https://www.europapark.de/',
      'https://fr.wikipedia.org/wiki/Europa-Park',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Europa-Park-Straße 2',
      addressLocality: 'Rust',
      postalCode: '77977',
      addressCountry: 'DE',
    },
  },
  efteling: {
    sameAs: [
      'https://www.efteling.com/',
      'https://fr.wikipedia.org/wiki/Efteling',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Europalaan 1',
      addressLocality: 'Kaatsheuvel',
      postalCode: '5171 KW',
      addressCountry: 'NL',
    },
  },
  phantasialand: {
    sameAs: [
      'https://www.phantasialand.de/',
      'https://fr.wikipedia.org/wiki/Phantasialand',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Berggeiststraße 31-41',
      addressLocality: 'Brühl',
      postalCode: '50321',
      addressCountry: 'DE',
    },
  },
  portaventura: {
    sameAs: [
      'https://www.portaventuraworld.com/',
      'https://fr.wikipedia.org/wiki/PortAventura_Park',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Avinguda Pere Molas, km 2',
      addressLocality: 'Vila-seca',
      postalCode: '43480',
      addressCountry: 'ES',
    },
  },
  gardaland: {
    sameAs: [
      'https://www.gardaland.it/',
      'https://fr.wikipedia.org/wiki/Gardaland',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Via Derna 4',
      addressLocality: 'Castelnuovo del Garda',
      postalCode: '37014',
      addressCountry: 'IT',
    },
  },
  'magic-kingdom': {
    sameAs: [
      'https://disneyworld.disney.go.com/destinations/magic-kingdom/',
      'https://fr.wikipedia.org/wiki/Magic_Kingdom',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '1180 Seven Seas Drive',
      addressLocality: 'Lake Buena Vista',
      postalCode: '32830',
      addressCountry: 'US',
    },
  },
  epcot: {
    sameAs: [
      'https://disneyworld.disney.go.com/destinations/epcot/',
      'https://fr.wikipedia.org/wiki/EPCOT',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '200 Epcot Center Drive',
      addressLocality: 'Lake Buena Vista',
      postalCode: '32830',
      addressCountry: 'US',
    },
  },
  'universal-studios': {
    sameAs: [
      'https://www.universalorlando.com/web/en/us/theme-parks/universal-studios-florida',
      'https://fr.wikipedia.org/wiki/Universal_Studios_Florida',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '6000 Universal Boulevard',
      addressLocality: 'Orlando',
      postalCode: '32819',
      addressCountry: 'US',
    },
  },
  'islands-of-adventure': {
    sameAs: [
      'https://www.universalorlando.com/web/en/us/theme-parks/islands-of-adventure',
      'https://fr.wikipedia.org/wiki/Universal_Islands_of_Adventure',
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: '6000 Universal Boulevard',
      addressLocality: 'Orlando',
      postalCode: '32819',
      addressCountry: 'US',
    },
  },
};

const POPULAR_PARKS_FOR_ITEMLIST = [
  { slug: 'europa-park', name: 'Europa-Park' },
  { slug: 'efteling', name: 'Efteling' },
  { slug: 'parc-asterix', name: 'Parc Astérix' },
  { slug: 'phantasialand', name: 'Phantasialand' },
  { slug: '', name: 'Disneyland Paris' },
  { slug: 'portaventura', name: 'PortAventura' },
  { slug: 'gardaland', name: 'Gardaland' },
  { slug: 'universal-studios', name: 'Universal Studios Florida' },
  { slug: 'futuroscope', name: 'Futuroscope' },
  { slug: 'energylandia', name: 'Energylandia' },
  { slug: 'epic-universe', name: 'Epic Universe' },
  { slug: 'walibi-belgium', name: 'Walibi Belgium' },
];

const SEO_RELEASE_LASTMOD = '2026-06-02';

const SEO_ROUTE_LASTMOD = {
  '/aquascope': '2026-05-31',
  '/puydufou': '2026-05-28',
};

const PARK_SEO_CONTENT = {
  puydufou: {
    lead: "La page Magic Park Times consacrée au Puy du Fou centralise le programme du jour, les horaires des spectacles et les prochaines séances disponibles pour préparer une visite aux Epesses. Elle donne une lecture rapide des représentations passées, des horaires d'ouverture, des restaurants et de la carte du parc.",
    highlights: [
      "Programme du jour du Puy du Fou avec horaires des spectacles, séances restantes et dates disponibles quand la donnée est exposée.",
      "Repères utiles pour préparer la visite : programme des spectacles, horaires d'ouverture, restaurants et carte du parc.",
      "Données vérifiées le 2026-05-28 pour suivre le programme et les horaires des spectacles.",
    ],
  },
  'parc-asterix': {
    lead: "La page Magic Park Times consacrée au Parc Astérix aide à préparer une visite à Plailly avec un accès direct aux temps d'attente des attractions, aux horaires d'ouverture et aux informations utiles du parc. Elle met en avant les files d'attente en temps réel pour les grands repères du parc comme Toutatis, OzIris, Tonnerre 2 Zeus, Pégase Express, Menhir Express, Romus et Rapidus ou Goudurix, lorsque les données sont disponibles. L'objectif est simple : vérifier rapidement si les attractions principales sont ouvertes, comparer les attentes et choisir le meilleur ordre de visite avant ou pendant la journée.",
    highlights: [
      "Repères dédiés aux attractions majeures du Parc Astérix, dont Toutatis, OzIris et Tonnerre 2 Zeus lorsque les données live sont disponibles.",
      "Données organisées pour comparer rapidement ouvertures, files d'attente et horaires utiles pendant la journée.",
      "Repères stables pour préparer une journée au Parc Astérix avant ou pendant la visite.",
    ],
  },
  'europa-park': {
    lead: "La page Magic Park Times consacrée à Europa-Park suit les temps d'attente du parc de Rust et donne un point d'entrée clair vers les horaires, l'état des attractions et les informations de visite. Elle aide à comparer les grands secteurs du parc et les attractions très demandées comme Voltron Nevera, Silver Star, Blue Fire, Wodan ou Arthur lorsque les données sont disponibles.",
    highlights: [
      "Repères utiles pour suivre les files d'attente Europa-Park et préparer une visite à Rust.",
      "Liens rapides vers les spectacles, restaurants et autres parcs populaires.",
      "Données centrées sur les informations réellement exposées par Magic Park Times.",
    ],
  },
  efteling: {
    lead: "La page Magic Park Times dédiée à Efteling centralise les temps d'attente du parc de Kaatsheuvel avec les horaires et informations utiles pour organiser une journée sur place. Elle sert de point d'entrée pour suivre les attractions emblématiques comme Baron 1898, Symbolica, Droomvlucht, Fata Morgana ou Joris en de Draak lorsque les données live sont disponibles.",
    highlights: [
      "Repères centrés sur Efteling, ses attractions clés et la consultation rapide des files d'attente.",
      "Données live, horaires et liens utiles présentés dans une structure lisible.",
      "Informations dédiées au parc de Kaatsheuvel et à ses attractions principales.",
    ],
  },
  phantasialand: {
    lead: "La page Magic Park Times pour Phantasialand aide à suivre les temps d'attente du parc de Brühl et à repérer les attractions à forte demande. Elle met en contexte les données disponibles pour des repères comme F.L.Y., Taron, Black Mamba, Chiapas ou Colorado Adventure, afin de faciliter les décisions de visite pendant la journée.",
    highlights: [
      "Repères propres à Phantasialand avec les attractions les plus suivies.",
      "Comparaison rapide des attentes, ouvertures et horaires quand la donnée est disponible.",
      "Informations dédiées au parc de Brühl et à ses zones principales.",
    ],
  },
  portaventura: {
    lead: "La page Magic Park Times consacrée à PortAventura suit les temps d'attente du resort de Salou et Vila-seca avec une URL canonique dédiée au parc principal. Elle facilite la comparaison des files autour des attractions majeures comme Shambhala, Dragon Khan, Furius Baco ou Uncharted lorsque les données sont disponibles, avec un lien distinct vers Ferrari Land.",
    highlights: [
      "Page distincte de Ferrari Land pour éviter la confusion entre les deux parcs du resort.",
      "Données de files d'attente et horaires structurées pour préparer une visite à PortAventura World.",
      "Liens utiles vers Ferrari Land et les autres parcs européens suivis.",
    ],
  },
  gardaland: {
    lead: "La page Magic Park Times pour Gardaland rassemble les temps d'attente et informations pratiques du parc situé près du lac de Garde. Elle sert de repère pour comparer les attractions les plus visibles du parc, comme Raptor, Oblivion, Mammut, Blue Tornado ou Jumanji lorsque les données live sont disponibles.",
    highlights: [
      "Repères dédiés à Gardaland, aux temps d'attente et à la préparation de visite.",
      "Horaires, état des attractions et liens utiles rassemblés au même endroit.",
      "Informations centrées sur les attractions du parc près du lac de Garde.",
    ],
  },
  'magic-kingdom': {
    lead: "La page Magic Park Times dédiée à Magic Kingdom suit les temps d'attente du parc Walt Disney World et regroupe les horaires, restaurants et spectacles associés. Elle donne un accès rapide aux attentes des zones les plus consultées, avec des repères comme Fantasyland, Tomorrowland, Adventureland et Frontierland lorsque les données live sont disponibles.",
    highlights: [
      "Page principale Magic Kingdom complétée par des sous-pages spectacles et restaurants.",
      "Données organisées pour vérifier rapidement les attractions ouvertes et les files d'attente importantes.",
      "Informations organisées autour du parc Walt Disney World et de ses zones principales.",
    ],
  },
  epcot: {
    lead: "La page Magic Park Times pour Epcot centralise les temps d'attente du parc Walt Disney World avec les horaires et informations de visite. Elle aide à suivre les zones World Celebration, World Discovery, World Nature et World Showcase, ainsi que les attractions très demandées lorsque les données live sont disponibles.",
    highlights: [
      "Page Epcot reliée aux sous-pages spectacles et restaurants.",
      "Repères centrés sur les horaires, les files et les attractions les plus utiles.",
      "Informations dédiées au parc Epcot et à ses zones principales.",
    ],
  },
  'universal-studios': {
    lead: "La page Magic Park Times consacrée à Universal Studios Florida suit les temps d'attente du parc Universal Orlando Resort avec les horaires et informations utiles. Elle donne un repère clair pour consulter les zones comme Diagon Alley, Springfield, Minion Land ou Production Central lorsque les données live sont disponibles.",
    highlights: [
      "Page Universal Studios Florida distincte de Islands of Adventure et Epic Universe.",
      "Données live et liens internes structurés pour comparer rapidement les attentes.",
      "Informations organisées autour du parc Universal Studios Florida.",
    ],
  },
  'islands-of-adventure': {
    lead: "La page Magic Park Times pour Islands of Adventure suit les temps d'attente du parc Universal Orlando Resort et aide à préparer une visite entre Hogsmeade, Jurassic Park, Marvel Super Hero Island et les autres zones du parc. Elle met en avant la comparaison rapide des files d'attente lorsque les données live sont disponibles.",
    highlights: [
      "Repères dédiés à Islands of Adventure, séparés des autres parcs Universal.",
      "Horaires, état des attractions et liens vers les pages liées.",
      "Informations utiles pour comparer les files entre Hogsmeade, Jurassic Park et Marvel Super Hero Island.",
    ],
  },
};

const SEO_FOOTER_VERIFIED_AT = '2026-05-28';

function createParkSeoFooterContent(config) {
  return {
    footerTitle: config.footerTitle,
    footerParagraphs: config.footerParagraphs,
    priority: config.priority || 'medium',
    verifiedAt: SEO_FOOTER_VERIFIED_AT,
    keywordSource: config.keywordSource || 'web',
  };
}

const EXCLUDED_SEO_FOOTER_PARKS = new Set([
  'traumatica',
]);

const DEFERRED_SEO_FOOTER_PARKS = new Set([
  'six-flags-qiddiyacity',
]);

const LOW_PRIORITY_SEO_FOOTER_PARKS = new Set([
  'nigloland',
  'grona-lund',
  'typhoon-lagoon',
  'blizzard-beach',
]);

const PARK_SEO_FOOTER_CONTENT = {
  'disneyland-paris': createParkSeoFooterContent({
    footerTitle: 'Préparer une visite à Disneyland Paris',
    priority: 'high',
    keywordSource: 'csv+web',
    footerParagraphs: [
      "Pour préparer une visite à Disneyland Paris sans passer la journée dans les files, Magic Park Times rassemble les temps d’attente Disneyland Paris, les horaires attractions Disneyland Paris et les tendances d’affluence utiles avant d’arriver. Les données aident à repérer les moments plus calmes pour Big Thunder Mountain, Hyperspace Mountain ou les rencontres personnages, puis à comparer l’attente en direct avec les spectacles et parades du jour.",
      "Cette page reste centrée sur le parc Disneyland Paris, sans la confondre avec Disney Adventure World ou Disneyland California. Elle sert de repère simple pour choisir le bon créneau, suivre l’attente attraction par attraction et garder du temps pour les lands, le château et les moments clés de la journée.",
    ],
  }),
  'walt-disney-studios': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Disney Adventure World',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Disney Adventure World, ancien Walt Disney Studios Park, concentre des recherches autour des temps d’attente Disney Adventure World, de World of Frozen, de Crush’s Coaster et des expériences Pixar ou MARVEL. Magic Park Times aide à suivre les attractions ouvertes, l’affluence et les variations de file au fil de la journée.",
      "Les visiteurs peuvent comparer l’attente de Crush’s Coaster, Frozen Ever After ou WEB Adventure avant de choisir leur prochain déplacement. Le texte garde aussi l’alias Walt Disney Studios Park temps d’attente pour accompagner la transition de nom sans créer de confusion avec Disney California Adventure.",
    ],
  }),
  puydufou: createParkSeoFooterContent({
    footerTitle: 'Horaires et programme des spectacles Puy du Fou',
    priority: 'high',
    keywordSource: 'csv+web',
    footerParagraphs: [
      "Avant de préparer une journée au Puy du Fou, vérifiez les horaires Puy du Fou, l’ouverture Puy du Fou et le programme des spectacles Puy du Fou. Les horaires des spectacles changent selon la date et l’affluence, ce qui rend les recherches comme horaire spectacle Puy du Fou ou programme du jour Puy du Fou particulièrement utiles pour organiser sa visite.",
      "Magic Park Times regroupe les informations pratiques du Grand Parc, les représentations, les restaurants et les repères de journée sans masquer le contenu dans l’interface. Quand les données sont disponibles, la page peut aussi aider à suivre les temps d’attente Puy du Fou et à distinguer les spectacles du jour, la Cinéscénie et les Noces de Feu.",
    ],
  }),
  'europa-park': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Europa-Park et horaires',
    priority: 'high',
    keywordSource: 'csv+web',
    footerParagraphs: [
      "Pour préparer une journée à Europa-Park, consultez les temps d'attente Europa-Park avant de choisir vos attractions prioritaires. Magic Park Times permet de suivre l’évolution des files et d’anticiper les moments plus calmes pour Voltron Nevera, WODAN, Poseidon ou les attractions familiales.",
      "Les horaires Europa-Park, les saisons et les spectacles peuvent varier selon la date. Cette page aide surtout à comparer l’affluence Europa-Park, repérer les pics et organiser un parcours plus fluide dans le parc de Rust, tout en distinguant clairement Europa-Park de Rulantica et du resort.",
    ],
  }),
  'parc-asterix': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Parc Astérix en direct',
    priority: 'high',
    keywordSource: 'csv+web',
    footerParagraphs: [
      "Pour organiser une visite au Parc Astérix, les visiteurs cherchent surtout les temps d’attente Parc Astérix, l’affluence du jour et les attractions à prioriser. Les données en direct, les horaires Parc Astérix et les solutions comme Filotomatix répondent à une intention pratique : passer moins de temps dans les files et mieux répartir sa journée.",
      "Cette page aide à préparer une journée à Plailly en comparant les files de Toutatis, OzIris, Tonnerre 2 Zeus, Pégase Express ou Menhir Express quand les données sont disponibles. Elle permet aussi de vérifier l’ouverture du parc, les horaires des spectacles et l’intérêt de Filotomatix avant de fixer son parcours.",
    ],
  }),
  futuroscope: createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Futuroscope en direct',
    priority: 'high',
    keywordSource: 'csv+web',
    footerParagraphs: [
      "Sur Magic Park Times, les temps d’attente Futuroscope aident à savoir si une attraction vaut le détour maintenant ou plus tard dans la journée. Ces repères complètent les horaires Futuroscope, le calendrier d’ouverture et les spectacles pour organiser une visite plus fluide.",
      "La page sert surtout à comparer l’attente en direct, l’attente moyenne et l’affluence autour des attractions majeures.",
    ],
  }),
  phantasialand: createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Phantasialand',
    priority: 'high',
    keywordSource: 'csv+web',
    footerParagraphs: [
      "Pour Phantasialand, suivre les temps d’attente Phantasialand est particulièrement utile si vous visez les attractions très demandées comme Taron, F.L.Y. ou les grands parcours immersifs. Magic Park Times aide à comparer l’affluence, repérer les pics et organiser un ordre de visite plus réaliste.",
      "Les horaires Phantasialand, l’ouverture des attractions et les spectacles doivent être vérifiés selon la journée. Cette page donne un repère clair pour suivre les files, compléter l’application officielle et choisir les moments les plus adaptés pour changer de zone.",
    ],
  }),
  portaventura: createParkSeoFooterContent({
    footerTitle: 'Temps d’attente PortAventura',
    priority: 'high',
    keywordSource: 'csv+web',
    footerParagraphs: [
      "Pour préparer une journée à PortAventura, les temps d’attente PortAventura aident à choisir le bon moment pour rejoindre Shambhala, Dragon Khan, Uncharted ou les attractions familiales. Cette page complète les horaires PortAventura avec une lecture simple des files d’attente, utile avant d’arriver comme pendant la visite.",
      "Les voyageurs qui cherchent PortAventura temps d’attente en direct, temps d’attente PortAventura août ou file d’attente Shambhala peuvent ainsi repérer les périodes plus calmes et organiser leur parcours sans multiplier les allers-retours. La page distingue le parc principal de Ferrari Land et du reste de PortAventura World.",
    ],
  }),
  'plopsaland-de-panne': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Plopsaland Belgium',
    priority: 'high',
    keywordSource: 'csv+web',
    footerParagraphs: [
      "Pour Plopsaland Belgium, les temps d'attente Plopsaland, les horaires de Plopsaland De Panne, les spectacles et l’application officielle aident à préparer une journée entre attractions, rencontres de personnages et shows.",
      "Les temps d’attente peuvent guider l’ordre des attractions et aider à éviter les allers-retours inutiles. La page reste centrée sur Plopsaland Belgium et distingue le parc principal de Plopsaqua ou Plopsa Coo.",
    ],
  }),
  bellewaerde: createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Bellewaerde',
    priority: 'high',
    keywordSource: 'csv+web',
    footerParagraphs: [
      "Bellewaerde demande souvent de choisir entre attractions, animaux et spectacles. Magic Park Times aide à consulter les temps d’attente Bellewaerde, les horaires Bellewaerde, les files des attractions populaires et les horaires des animations avant de se déplacer dans le parc.",
      "La page permet aussi de suivre l’affluence Bellewaerde et les attentes aux attractions au fil de la journée. Elle distingue Bellewaerde Park de Bellewaerde Aquapark afin de garder une réponse utile pour les visiteurs du parc principal.",
    ],
  }),
  'walibi-holland': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Walibi Holland',
    priority: 'high',
    keywordSource: 'csv+web',
    footerParagraphs: [
      "Sur Magic Park Times, suivez les temps d’attente Walibi Holland pour préparer votre visite à Biddinghuizen. La page aide à comparer l’affluence par attraction, repérer les moments plus calmes et anticiper les files sur les grands coasters comme UNTAMED, Goliath, Lost Gravity ou YOY.",
      "Les horaires Walibi Holland, les wachttijden Walibi Holland, l’openingstijden Walibi Holland et les options Fast Lane sont utiles pour choisir le bon moment d’arrivée. La page précise toujours Walibi Holland afin d’éviter la confusion avec les autres parcs Walibi.",
    ],
  }),
  'magic-kingdom': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Magic Kingdom',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Magic Kingdom concentre des attractions très demandées, des classiques familiaux et des files qui changent vite selon les horaires, la météo ou les événements. Sur Magic Park Times, les temps d’attente Magic Kingdom et les tendances d’affluence aident à décider quand viser TRON Lightcycle Run, Seven Dwarfs Mine Train, Space Mountain ou Haunted Mansion.",
      "Les visiteurs peuvent suivre les Magic Kingdom wait times, repérer les périodes plus calmes et adapter leur parcours sans dépendre uniquement d’un planning figé. Magic Kingdom est l'un des parcs du resort de Walt Disney World en Floride.",
    ],
  }),
  'hollywood-studios': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Hollywood Studios',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Hollywood Studios peut vite concentrer l’affluence autour de Star Wars: Galaxy’s Edge, Toy Story Land et des grands spectacles. Avec Magic Park Times, les temps d’attente Hollywood Studios donnent un aperçu clair des wait times et des créneaux plus intéressants pour Rise of the Resistance, Slinky Dog Dash, Tower of Terror ou Mickey & Minnie’s Runaway Railway.",
      "La page permet de suivre les attractions ouvertes, les pics d’attente et les moments où changer de zone devient pertinent. Le contenu précise Disney Hollywood Studios afin d’éviter la confusion avec Universal Studios Hollywood ou l’ancien nom Disney-MGM Studios.",
    ],
  }),
  'universal-studios': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Universal Studios Florida',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Pour préparer une journée à Universal Studios Florida, les temps d’attente restent un repère utile avant de choisir entre Diagon Alley, Minion Land, DreamWorks Land ou les attractions plus intenses. Cette page aide à suivre l’affluence Universal Studios Orlando, repérer les moments plus calmes et comparer l’attente des principales attractions.",
      "Magic Park Times complète l’application officielle Universal Orlando avec des repères de visite, des horaires Universal Studios Florida et des attractions comme Escape from Gringotts temps d’attente.",
    ],
  }),
  'islands-of-adventure': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Islands of Adventure',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Islands of Adventure concentre plusieurs attractions dont l’attente peut vite orienter la journée, de Hagrid’s Magical Creatures Motorbike Adventure à Jurassic World VelociCoaster, Spider-Man ou The Incredible Hulk Coaster. Suivre les temps d’attente Islands of Adventure permet de mieux choisir entre Hogsmeade, Jurassic Park, Marvel Super Hero Island et les zones familiales.",
      "Magic Park Times aide à lire l’affluence Universal Islands of Adventure et à repérer les créneaux où les files semblent plus favorables.",
    ],
  }),
  'epic-universe': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Epic Universe',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Universal Epic Universe attire beaucoup de recherches liées aux temps d’attente, car chaque monde demande des choix différents entre Super Nintendo World, Dark Universe, Celestial Park, Isle of Berk et le Ministry of Magic. Sur cette page, l’objectif est d’aider les visiteurs à anticiper l’affluence Universal Epic Universe et à comparer l’attente des attractions majeures.",
      "Les temps d’attente Epic Universe, Battle at the Ministry ou Mine-Cart Madness donnent des repères concrets pour ajuster son parcours. Epic Universe est le dernier nouveau parc Universal ouvert en Floride.",
    ],
  }),
  'universal-studios-california': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Universal Studios Hollywood',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Universal Studios Hollywood est souvent recherché sous les noms Universal Studios California ou Universal Hollywood, surtout par les visiteurs qui veulent comparer les temps d’attente avant d’arriver à Los Angeles. Entre le Studio Tour, Super Nintendo World, Jurassic World, Harry Potter et les nouveautés du parc, l’affluence peut changer rapidement.",
      "Cette page aide à suivre les files, préparer les priorités et compléter les informations de l’application officielle.",
    ],
  }),
  'seaworld-orlando': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente SeaWorld Orlando',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "SeaWorld Orlando combine montagnes russes, attractions aquatiques, zones animalières et spectacles, ce qui rend les temps d’attente utiles pour équilibrer la journée. Suivre l’affluence SeaWorld Orlando aide à choisir le bon moment pour Mako, Manta, Kraken, Pipeline ou Infinity Falls.",
      "Magic Park Times peut compléter l’application SeaWorld et donner aux visiteurs un aperçu clair des attentes possibles avant de se déplacer dans le parc. Les horaires spectacles SeaWorld Orlando restent associés au parc de Floride afin d’éviter la confusion avec San Diego ou San Antonio.",
    ],
  }),
  'tokyo-disneyland': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Tokyo Disneyland',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Pour préparer une journée à Tokyo Disneyland, Magic Park Times permet de suivre les temps d’attente Tokyo Disneyland, de repérer les files qui montent vite et de comparer les tendances avant d’entrer dans le parc. Les visiteurs recherchent souvent les horaires Tokyo Disneyland, l’application Tokyo Disney Resort, le Disney Premier Access ou le Priority Pass.",
      "La page aide à vérifier l’attente en direct pour Beauty and the Beast, Baymax, Pooh’s Hunny Hunt et les classiques de Fantasyland. Le contenu associe toujours Tokyo et Tokyo Disney Resort pour éviter la confusion avec Disneyland Paris, Disneyland California ou Hong Kong Disneyland.",
    ],
  }),
  'tokyo-disneysea': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Tokyo DisneySea',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Tokyo DisneySea attire une recherche très spécifique autour des temps d’attente Tokyo DisneySea, de Fantasy Springs, de Soaring, Tower of Terror et des grands parcours de Mysterious Island. Magic Park Times rappelle que la page sert à suivre l’attente en direct, préparer les horaires de visite et comparer les attractions qui varient le plus selon la journée.",
      "Les visiteurs peuvent croiser ces informations avec l’application Tokyo Disney Resort, le Disney Premier Access et les options de Priority Pass. La page reste dédiée à Tokyo DisneySea et ne mélange pas ses données avec celles de Tokyo Disneyland.",
    ],
  }),
  hersheypark: createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Hersheypark',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Pour Hersheypark, la page vise les visiteurs qui veulent croiser temps d’attente Hersheypark, horaires, disponibilité des attractions et affluence avant une journée à Hershey. Magic Park Times apporte une lecture simple des files, en complément de l’application officielle, avec des repères pour choisir les premières attractions et éviter les pics.",
      "Les Hersheypark wait times, le Hershey Park crowd calendar et les horaires Hersheypark aident à adapter le parcours selon la fréquentation. La page distingue le parc des informations liées à ZooAmerica, Hershey’s Chocolate World ou aux salles de spectacle du resort.",
    ],
  }),
  'kings-island': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Kings Island',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Pour Kings Island, Magic Park Times aide à suivre les temps d’attente Kings Island, l’affluence, les horaires et les grandes attractions comme Orion, Diamondback, Banshee ou Mystic Timbers. La page aide à comparer les files, repérer les jours plus calmes et suivre les horaires officiels.",
      "Les Kings Island wait times, le crowd calendar Kings Island et les options Fast Lane Kings Island donnent des repères pratiques pour une visite dans l’Ohio. La page évite la confusion avec Kings Dominion, Soak City ou Cedar Point.",
    ],
  }),
  'knotts-berry-farm': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Knott’s Berry Farm',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Pour préparer une visite à Knott’s Berry Farm, Magic Park Times aide à comparer les temps d’attente Knott’s Berry Farm, l’affluence attendue et les horaires officiels avant de partir à Buena Park. Les visiteurs cherchent souvent à savoir quand éviter les longues files, quelles montagnes russes viser en premier et si Fast Lane vaut le coup selon la journée.",
      "Un suivi sobre des attentes, des ouvertures d’attractions et des moments plus calmes rend la page utile sans remplacer l’application officielle. La page distingue Knott’s Berry Farm de Knott’s Soak City, Scary Farm et des autres événements du resort.",
    ],
  }),
  carowinds: createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Carowinds',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Pour Carowinds, Magic Park Times aide à comparer les temps d’attente Carowinds, l’affluence et les horaires avant une journée entre Charlotte et les Carolines. La page met en avant les files des grandes attractions, les périodes plus calmes et les différences entre parc principal et Carolina Harbor.",
      "L’objectif est de guider la planification : vérifier les heures d’ouverture, repérer les attractions très demandées comme Fury 325 ou Copperhead Strike, et décider si une option Fast Lane est utile selon le niveau de foule.",
    ],
  }),
  'silver-dollar-city': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente Silver Dollar City',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Pour Silver Dollar City, les visiteurs recherchent souvent les temps d’attente Silver Dollar City, les horaires, les spectacles et les options pour gagner du temps pendant une journée à Branson. Magic Park Times présente la page comme un complément pratique pour anticiper l’affluence, suivre les files des montagnes russes et repérer les créneaux plus calmes.",
      "Les Silver Dollar City ride wait times, TrailBlazer Silver Dollar City et les conditions météo peuvent influencer l’ordre de visite, car certaines attractions dépendent fortement de la journée. La page reste centrée sur le parc de Branson et ses attractions.",
    ],
  }),
  'la-ronde': createParkSeoFooterContent({
    footerTitle: 'Temps d’attente La Ronde',
    priority: 'high',
    keywordSource: 'web',
    footerParagraphs: [
      "Pour La Ronde, Magic Park Times aide les visiteurs de Montréal à vérifier les temps d’attente La Ronde, les manèges ouverts, les horaires La Ronde, l’achalandage et les options d’accès rapide avant leur arrivée.",
      "La page sert à préparer une journée plus fluide entre montagnes russes, manèges familiaux, spectacles et feux. Elle précise Six Flags La Ronde quand c’est utile, sans confondre Accès Rapide, Flash Pass et Fast Lane.",
    ],
  }),
};

PARK_SEO_FOOTER_CONTENT['six-flags-qiddiyacity'] = createParkSeoFooterContent({
  footerTitle: 'Six Flags Qiddiya City',
  priority: 'deferred',
  keywordSource: 'web',
  footerParagraphs: [
    "Six Flags Qiddiya City mérite une page de suivi dès que les données d’attente sont fiables. Le parc de Riyad concentre des intentions éditoriales autour de Falcons Flight, des attractions records, des billets et du GoFast Pass, mais les CSV ne prouvent pas encore une demande francophone temps d’attente suffisante.",
  ],
});

function createGenericParkSeoFooterContent(internalParkSlug) {
  const parkName = PARK_NAMES[internalParkSlug];
  const priority = LOW_PRIORITY_SEO_FOOTER_PARKS.has(internalParkSlug) ? 'low' : 'medium';

  return createParkSeoFooterContent({
    footerTitle: `Préparer une visite à ${parkName}`,
    priority,
    keywordSource: 'web',
    footerParagraphs: [
      `Pour préparer une visite à ${parkName}, Magic Park Times aide à suivre les temps d'attente ${parkName}, les horaires ${parkName} et les repères d’affluence utiles au fil de la journée. Cette page permet de comparer les attractions ouvertes, d’identifier les moments plus calmes et de construire un parcours plus réaliste.`,
    ],
  });
}

function attachSeoFootersToParkContent() {
  Object.keys(PARK_NAMES).forEach((internalParkSlug) => {
    if (EXCLUDED_SEO_FOOTER_PARKS.has(internalParkSlug)) return;

    const footer = PARK_SEO_FOOTER_CONTENT[internalParkSlug]
      || createGenericParkSeoFooterContent(internalParkSlug);
    const currentContent = PARK_SEO_CONTENT[internalParkSlug] || {};

    PARK_SEO_CONTENT[internalParkSlug] = Object.assign({}, currentContent, { footer });
  });
}

attachSeoFootersToParkContent();

const HIGH_PRIORITY_SITEMAP_PARK_PATHS = new Set([
  '/europa-park',
  '/efteling',
  '/parc-asterix',
  '/phantasialand',
  '/portaventura',
  '/gardaland',
  '/disney-adventure-world',
  '/disneyland-california',
  '/disney-california-adventure',
  '/magic-kingdom',
  '/epcot',
  '/hollywood-studios',
  '/animal-kingdom',
  '/tokyo-disneyland',
  '/shanghai-disneyland',
  '/hong-kong-disneyland-park',
  '/universal-studios',
  '/islands-of-adventure',
  '/epic-universe',
  '/universal-studios-california',
]);

const ADDITIONAL_SITEMAP_ROUTES = [
  { path: '/parks', changefreq: 'daily', priority: '0.9' },
  { path: '/shows', changefreq: 'daily', priority: '0.8' },
  { path: '/parc-asterix/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/europa-park/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/efteling/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/phantasialand/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/futuroscope/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/disneyland-resort/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/disneyland-california/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/disney-california-adventure/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/universal-studios/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/universal-studios-california/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/islands-of-adventure/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/epic-universe/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/universal-studios-beijing/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/magic-kingdom/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/epcot/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/hollywood-studios/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/animal-kingdom/shows', changefreq: 'daily', priority: '0.7' },
  { path: '/restaurants', changefreq: 'daily', priority: '0.8' },
  { path: '/parc-asterix/restaurants', changefreq: 'daily', priority: '0.7' },
  { path: '/magic-kingdom/restaurants', changefreq: 'daily', priority: '0.7' },
  { path: '/epcot/restaurants', changefreq: 'daily', priority: '0.7' },
  { path: '/hollywood-studios/restaurants', changefreq: 'daily', priority: '0.7' },
  { path: '/animal-kingdom/restaurants', changefreq: 'daily', priority: '0.7' },
  { path: '/disneyland-resort/restaurants', changefreq: 'daily', priority: '0.7' },
  { path: '/about', changefreq: 'monthly', priority: '0.5' },
  { path: '/conditions-utilisation', lastmod: '2026-05-25', changefreq: 'monthly', priority: '0.4' },
  { path: '/conditions-generales-vente', lastmod: '2026-05-25', changefreq: 'monthly', priority: '0.4' },
  { path: '/politique-confidentialite', lastmod: '2026-05-25', changefreq: 'monthly', priority: '0.4' },
  { path: '/my-pass', changefreq: 'monthly', priority: '0.5' },
  { path: '/asterix-pass', changefreq: 'monthly', priority: '0.5' },
  { path: '/dispatch-max', lastmod: '2026-05-27', changefreq: 'monthly', priority: '0.6' },
  { path: '/support-us', changefreq: 'monthly', priority: '0.5' },
  { path: '/contact', changefreq: 'monthly', priority: '0.5' },
];

const INDEXABLE_PARK_SUBPAGE_ROUTES = new Set(
  ADDITIONAL_SITEMAP_ROUTES
    .map((route) => normalizePath(route.path))
    .filter((routePath) => {
      const segments = routePath.split('/').filter(Boolean);
      return segments.length === 2 && ['shows', 'restaurants'].includes(segments[1]);
    })
);

function getParkSeoContent(routePathOrSlug) {
  const slug = String(routePathOrSlug || '').startsWith('/')
    ? getRouteInfo(routePathOrSlug).internalParkSlug
    : routePathOrSlug;

  return PARK_SEO_CONTENT[slug] || null;
}

function getParkSeoFooterContent(routePathOrSlug) {
  const input = String(routePathOrSlug || '');
  let slug = input;

  if (input.startsWith('/')) {
    const canonicalPath = getCanonicalPath(input);

    if (shouldNoIndex(canonicalPath)) return null;

    const routeInfo = getRouteInfo(canonicalPath);
    if (routeInfo.segments.length > 1) return null;

    slug = canonicalPath === '/'
      ? 'disneyland-paris'
      : routeInfo.internalParkSlug;
  }

  if (!slug || !PARK_NAMES[slug] || DEFERRED_SEO_FOOTER_PARKS.has(slug)) return null;

  const footer = PARK_SEO_CONTENT[slug]?.footer || null;
  if (!footer || footer.priority === 'deferred') return null;

  return footer;
}

function buildSitemapEntries(options = {}) {
  const entries = [];
  const seen = new Set();
  const defaultLastmod = options.defaultLastmod || SEO_RELEASE_LASTMOD;
  const lastmodByPath = Object.assign({}, SEO_ROUTE_LASTMOD, options.lastmodByPath || {});

  const addEntry = (routePath, config = {}) => {
    const path = getCanonicalPath(routePath);
    if (seen.has(path) || shouldNoIndex(path)) return;
    if (!isKnownSeoRoute(path)) return;

    seen.add(path);
    entries.push({
      path,
      loc: `${SITE_URL}${path === '/' ? '/' : path}`,
      lastmod: config.lastmod || lastmodByPath[path] || defaultLastmod,
      changefreq: config.changefreq || 'daily',
      priority: config.priority || '0.8',
    });
  };

  addEntry('/', { changefreq: 'daily', priority: '1.0' });

  Object.keys(PARK_NAMES).forEach((internalParkSlug) => {
    const path = getPublicParkPath(internalParkSlug);
    if (path === '/') return;
    addEntry(path, {
      changefreq: 'hourly',
      priority: HIGH_PRIORITY_SITEMAP_PARK_PATHS.has(path) ? '0.9' : '0.8',
    });
  });

  ADDITIONAL_SITEMAP_ROUTES.forEach((route) => addEntry(route.path, route));

  return entries;
}

function normalizePath(inputPath) {
  if (!inputPath || inputPath === '/') {
    return '/';
  }

  const withLeadingSlash = inputPath.startsWith('/') ? inputPath : `/${inputPath}`;
  return withLeadingSlash.replace(/\/+$/, '') || '/';
}

function stripLegacyLocalePrefix(routePath) {
  const segments = normalizePath(routePath).split('/').filter(Boolean);
  const firstSegment = segments[0];

  if (!LEGACY_LOCALE_PREFIXES.has(firstSegment)) {
    return normalizePath(routePath);
  }

  if (segments.length === 1) {
    return '/';
  }

  if (segments.length === 2 && LEGACY_LOCALE_PREFIXES.has(segments[1])) {
    return '/';
  }

  return `/${segments.slice(1).join('/')}`;
}

function getCanonicalPath(routePath) {
  let normalized = normalizePath(routePath);
  let localeStrippedPath = stripLegacyLocalePrefix(normalized);

  while (localeStrippedPath !== normalized) {
    normalized = localeStrippedPath;
    localeStrippedPath = stripLegacyLocalePrefix(normalized);
  }

  for (const [legacyPath, canonicalPath] of Object.entries(LEGACY_ROUTE_REDIRECTS)) {
    if (normalized === legacyPath) {
      return canonicalPath;
    }

    if (normalized.startsWith(`${legacyPath}/`)) {
      if (canonicalPath === '/') {
        return normalized.slice(legacyPath.length) || '/';
      }

      return `${canonicalPath}${normalized.slice(legacyPath.length)}`;
    }
  }

  return normalized;
}

function getInternalParkSlugForPublicSlug(publicSlug) {
  return PUBLIC_PARK_SLUG_ALIASES[publicSlug] || publicSlug;
}

function getPublicParkSlug(internalParkSlug) {
  return INTERNAL_PARK_PUBLIC_SLUGS[internalParkSlug] || internalParkSlug;
}

function getPublicParkPath(internalParkSlug) {
  return `/${getPublicParkSlug(internalParkSlug)}`;
}

function getRouteInfo(routePath) {
  const normalized = normalizePath(routePath);
  const canonicalPath = getCanonicalPath(normalized);
  const segments = canonicalPath.split('/').filter(Boolean);
  const publicParkSlug = segments[0] || '';
  const internalParkSlug = getInternalParkSlugForPublicSlug(publicParkSlug);

  return {
    normalized,
    canonicalPath,
    segments,
    publicParkSlug,
    internalParkSlug,
    subPage: segments[1] || null,
  };
}

function titleCaseFromSlug(slug) {
  return String(slug || '')
    .split('-')
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ');
}

function parseSitemapRoutes(xml) {
  const locMatches = String(xml || '').match(/<loc>(.*?)<\/loc>/g) || [];
  return locMatches
    .map((tag) => tag.replace('<loc>', '').replace('</loc>', '').trim())
    .map((urlString) => {
      try {
        const url = new URL(urlString);
        return normalizePath(url.pathname);
      } catch {
        return null;
      }
    })
    .filter(Boolean);
}

function collectSeoRoutePaths(sitemapXml) {
  const routes = new Set(['/']);
  Object.keys(STATIC_ROUTE_META).forEach((routePath) => routes.add(normalizePath(routePath)));
  parseSitemapRoutes(sitemapXml).forEach((routePath) => routes.add(getCanonicalPath(routePath)));
  return Array.from(routes).sort((a, b) => a.localeCompare(b));
}

function shouldNoIndex(routePath) {
  const normalized = normalizePath(routePath);
  return NOINDEX_PATH_PREFIXES.some((prefix) => normalized.startsWith(prefix))
    || normalized.endsWith('/tv')
    || normalized.includes('/tv/');
}

function isIndexableParkSubpageRoute(routePath) {
  return INDEXABLE_PARK_SUBPAGE_ROUTES.has(getCanonicalPath(routePath));
}

function isKnownSeoRoute(routePath) {
  const normalized = getCanonicalPath(routePath);
  if (normalized === '/') return true;
  if (STATIC_ROUTE_META[normalized]) return true;
  if (shouldNoIndex(normalized)) return true;

  const { segments, publicParkSlug, internalParkSlug, subPage } = getRouteInfo(normalized);
  if (!publicParkSlug) return false;

  if (segments.length === 2 && ['shows', 'restaurants'].includes(subPage)) {
    return isIndexableParkSubpageRoute(normalized);
  }
  if (!PARK_NAMES[internalParkSlug]) return false;
  if (segments.length === 1) return true;

  return false;
}

function getStaticOgImageForPath(routePath) {
  const staticMeta = STATIC_ROUTE_META[getCanonicalPath(routePath)];
  return staticMeta?.image || null;
}

function resolveOgImage(routePath, options = {}) {
  const normalized = getCanonicalPath(routePath);
  const staticImage = getStaticOgImageForPath(normalized);
  if (staticImage) return staticImage;

  const { segments, internalParkSlug } = getRouteInfo(normalized);
  if (segments.length === 0) {
    return `${SITE_URL}/images/og/og-home.jpg`;
  }

  const ogImageExists = typeof options.ogImageExists === 'function'
    ? options.ogImageExists
    : () => true;

  if (segments[0] === 'portaventura' && segments[1] === 'ferrari-land' && ogImageExists('ferrari-land')) {
    return `${SITE_URL}/images/og/og-ferrari-land.jpg`;
  }

  if (ogImageExists(internalParkSlug)) {
    return `${SITE_URL}/images/og/og-${internalParkSlug}.jpg`;
  }

  return `${SITE_URL}/images/og/og-home.jpg`;
}

function buildDynamicMeta(routePath) {
  const { segments, publicParkSlug, internalParkSlug, subPage } = getRouteInfo(routePath);
  const parkName = PARK_NAMES[internalParkSlug] || titleCaseFromSlug(publicParkSlug);

  if (segments.length === 1 && publicParkSlug && !RESERVED_NON_PARK_SEGMENTS.has(publicParkSlug)) {
    return {
      title: `Temps d'attente ${parkName} en Direct - Files d'attente & Horaires | Magic Park Times`,
      description: `Temps d'attente ${parkName} en direct : files d'attente attraction par attraction, horaires d'ouverture, affluence et conseils pour organiser votre visite.`,
    };
  }

  if (segments.length >= 2 && publicParkSlug && !RESERVED_NON_PARK_SEGMENTS.has(publicParkSlug)) {
    if (subPage === 'shows') {
      return {
        title: `Spectacles ${parkName} - Horaires en direct | Magic Park Times`,
        description: `Spectacles ${parkName} : horaires, programme du jour et événements à suivre pour planifier vos pauses entre deux attractions.`,
      };
    }

    if (subPage === 'restaurants') {
      return {
        title: `Restaurants ${parkName} - Guide & Infos | Magic Park Times`,
        description: `Restaurants ${parkName} : points de restauration, infos pratiques et repères utiles pour choisir où manger pendant votre journée.`,
      };
    }

    if (subPage === 'map') {
      return {
        title: `Carte interactive ${parkName} | Magic Park Times`,
        description: `Carte interactive ${parkName} avec les temps d'attente, les attractions, restaurants et services pour vous repérer dans le parc.`,
      };
    }
  }

  const fallback = STATIC_ROUTE_META['/'];
  return { title: fallback.title, description: fallback.description };
}

function getSeoMetaForRoute(routePath, options = {}) {
  const normalized = normalizePath(routePath);
  const canonicalPath = getCanonicalPath(normalized);
  const staticMeta = STATIC_ROUTE_META[canonicalPath];
  const isKnownRoute = isKnownSeoRoute(canonicalPath);
  const dynamicMeta = isKnownRoute
    ? (staticMeta || buildDynamicMeta(canonicalPath))
    : {
      title: 'Page introuvable - Magic Park Times',
      description: "Cette page Magic Park Times n'existe pas ou n'est plus disponible.",
    };
  const canonicalUrl = `${SITE_URL}${canonicalPath === '/' ? '' : canonicalPath}`;

  return {
    title: dynamicMeta.title,
    description: dynamicMeta.description,
    canonicalUrl,
    ogImage: isKnownRoute ? resolveOgImage(canonicalPath, options) : STATIC_ROUTE_META['/'].image,
    noindex: shouldNoIndex(normalized) || !isKnownRoute,
  };
}

module.exports = {
  SITE_URL,
  ORGANIZATION_SCHEMA,
  PARK_NAMES,
  PUBLIC_PARK_SLUG_ALIASES,
  INTERNAL_PARK_PUBLIC_SLUGS,
  LEGACY_ROUTE_REDIRECTS,
  STATIC_ROUTE_META,
  NOINDEX_PATH_PREFIXES,
  RESERVED_NON_PARK_SEGMENTS,
  PARK_GEO,
  PARK_ENTITY_DETAILS,
  POPULAR_PARKS_FOR_ITEMLIST,
  SEO_RELEASE_LASTMOD,
  SEO_ROUTE_LASTMOD,
  PARK_SEO_CONTENT,
  getParkSeoContent,
  getParkSeoFooterContent,
  buildSitemapEntries,
  normalizePath,
  getCanonicalPath,
  getInternalParkSlugForPublicSlug,
  getPublicParkSlug,
  getPublicParkPath,
  getRouteInfo,
  parseSitemapRoutes,
  collectSeoRoutePaths,
  shouldNoIndex,
  isIndexableParkSubpageRoute,
  isKnownSeoRoute,
  getStaticOgImageForPath,
  resolveOgImage,
  buildDynamicMeta,
  getSeoMetaForRoute,
  titleCaseFromSlug,
};
